// NPM
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { omitBy, isNil, isEmpty } from "lodash";

// UTILITY
import errorHandler from "Utils/error-handler";

// VALIDATOR
import { IssueTypeFormSchema } from "./issue-type-form-validation";

// STYLE
import "./issue-type-form.scss";

// ANT COMPONENTS
import { Input, Col, Row } from "antd";
import { AlertBox, Button, TextInput } from "@life-line-lab/components-react";

interface IssueTypeForm {
  info?: any;
  onSubmit?: any;
  onUpdate?: any;
}

const IssueTypeFormComponent: React.FC<IssueTypeForm> = ({ info, onSubmit, onUpdate }) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const initialInput = {
    name: "",
    remark: "",
  };
  const initialError = {};

  const [input, setInput] = useState(initialInput);
  const [error, setError] = useState<any>(initialError);

  useEffect(() => {
    document.body.classList.add("stack-screen--open");
    return () => document.body.classList.remove("stack-screen--open");
  }, []);

  useEffect(() => {
    if (!isNil(info)) {
      setInput({
        ...input,
        ...info,
      });
    }
  }, [info]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setError(initialError);
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    try {
      const valInput = {
        ...input,
        settingID: info?._id,
      };
      const value = IssueTypeFormSchema.validateSync(
        { ...omitBy(valInput, isEmpty) },
        {
          strict: false,
          abortEarly: true,
          stripUnknown: true,
        },
      );
      console.log(value);
      info ? onUpdate(value) : onSubmit(value);
    } catch (err) {
      const { path, value }: any = errorHandler.validation(err);
      setError({ ...error, [path]: t(`${value}`, { field: t(`label.${path}`) }) });
    }
  };

  return (
    <div className="issue-type-form">
      <form>
        <div className="main-header">
          <span className="center header-title">{t("label.issueType").toUpperCase()}</span>
        </div>
        <Row className="mt-40" justify="center">
          <Col sm={24} md={16} className="mb-0">
            <Row>
              <Col span={24} className={"mb-30"}>
                <TextInput
                  isRequired={true}
                  label={t("label.issueType")}
                  placeholder={t("txt.issueType")}
                  value={input.name}
                  name="name"
                  onChange={handleChange}
                />
                <AlertBox text={error.name} />
              </Col>
            </Row>
            <label className="inp-label inp-label--required">{t("label.remark")}</label>
            <Input.TextArea
              id="remark"
              size="middle"
              rows={3}
              name="remark"
              value={input.remark}
              onChange={handleChange}
              required={true}
              placeholder={t("txt.remarks")}
            />
            <AlertBox text={error.remark} />
          </Col>
        </Row>
        <Row className="mt-50" justify="center">
          <Col className="mb-50">
            <Button
              size="large"
              type="primary"
              onClick={handleSubmit}
              label={id ? t("action.update") : t("action.create")}
            />
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default IssueTypeFormComponent;
